module.exports = __webpack_public_path__ + "img/pd-img9.d7b82312.png";